// src/constants/colors.js

export const creatorOrange = "#FF872F";
export const brandGreen = "#00B1B5";